import * as React from 'react';

import { Pill, color } from '@coursera/coursera-ui';
import { SvgClear } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/admin-dashboard';

type Props = {
  label: string;
  type: string | number;
  onDismiss: () => void;
  rootClassName: string;
};

class FilterPill extends React.Component<Props> {
  handleDismiss = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { onDismiss } = this.props;
    e.stopPropagation();
    onDismiss();
  };

  render() {
    const { label, rootClassName, type } = this.props;
    return (
      <Pill
        size="md"
        type="filled"
        fillColor={color.dividerLight}
        label={label}
        tag="div"
        rootClassName={rootClassName}
      >
        <button type="button" data-testid="FilterPill_button" className="nostyle" onClick={this.handleDismiss}>
          <SvgClear
            size={17}
            color={color.lightGrayText}
            hoverColor={color.black}
            title={_t('clear #{filterType}', { filterType: type })}
          />
        </button>
      </Pill>
    );
  }
}

export default FilterPill;
